export default __webpack_public_path__ + "static/media/blazeVanMobile.0162e274.jpg";